import { useTranslations } from 'next-intl'
import { z } from 'zod'

export const createZResetPasswordForm = (
  t: ReturnType<typeof useTranslations<'reset_password'>>,
) =>
  z
    .object({
      newPassword: z
        .string()
        .trim()
        .min(1, {
          message: t('new_password_error_empty_format'),
        })
        .regex(
          /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+=\-{}[\]:;"'<>,.?/~]{6,15}$/,
          {
            message: t('new_password_error_invalid_format'),
          },
        ),
      newPasswordConfirm: z
        .string()
        .trim()
        .min(1, {
          message: t('confirm_new_password_error_empty_format'),
        }),
    })
    .refine(data => data.newPassword === data.newPasswordConfirm, {
      message: t('confirm_new_password_error_mismatch'),
      path: ['newPasswordConfirm'],
    })

export type TResetPasswordForm = z.infer<
  ReturnType<typeof createZResetPasswordForm>
>

export const defaultValues: TResetPasswordForm = {
  newPassword: '',
  newPasswordConfirm: '',
}
